// frontend/src/components/common/VideoEmbedPlayer.tsx

import React, { useState } from 'react';
import { parseVideoUrl } from '../../utils/videoUtils';

interface VideoEmbedPlayerProps {
  url: string;
  title?: string;
  className?: string;
  style?: React.CSSProperties;
  showExternalLink?: boolean;
}

export const VideoEmbedPlayer: React.FC<VideoEmbedPlayerProps> = ({
  url,
  title = 'Ders Anlatım Videosu',
  className = '',
  style,
  showExternalLink = true,
}) => {
  const parsed = parseVideoUrl(url);
  const [iframeError, setIframeError] = useState(false);

  if (!parsed.rawUrl || parsed.type === 'unknown') {
    return (
      <div style={{ padding: 16, textAlign: 'center', background: '#f8fafc', color: '#64748b', borderRadius: 12, fontSize: 13 }}>
        Geçerli bir video bağlantısı bulunamadı.
      </div>
    );
  }

  return (
    <div className={`video-embed-player-wrapper ${className}`} style={{ width: '100%', ...style }}>
      <div className="lesson-video-player" style={{ position: 'relative', width: '100%', borderRadius: 16, overflow: 'hidden' }}>
        {parsed.type === 'direct' ? (
          <video
            controls
            controlsList="nodownload"
            preload="metadata"
            src={parsed.embedUrl!}
            style={{ width: '100%', height: '100%', display: 'block', objectFit: 'contain' }}
          >
            Tarayıcınız video oynatmayı desteklemiyor.
          </video>
        ) : parsed.embedUrl && !iframeError ? (
          <iframe
            src={parsed.embedUrl}
            title={title}
            referrerPolicy="strict-origin-when-cross-origin"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            loading="lazy"
            onError={() => setIframeError(true)}
            style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
          />
        ) : (
          <div style={{ padding: '32px 16px', textAlign: 'center', background: '#0F172A', color: '#F8FAFC', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12, height: '100%' }}>
            <span style={{ fontSize: 32 }}>🎬</span>
            <p style={{ margin: 0, fontSize: 14, fontWeight: 500 }}>
              Bu video doğrudan iframe içerisinde gösterilemiyor veya gömülmeye izin vermiyor.
            </p>
            <a
              href={parsed.rawUrl}
              target="_blank"
              rel="noreferrer"
              className="lesson-btn primary sm"
              style={{ display: 'inline-flex', alignItems: 'center', gap: 6, textDecoration: 'none', padding: '8px 18px', borderRadius: 100 }}
            >
              ▶️ Videoyu Yeni Sekmede İzle
            </a>
          </div>
        )}
      </div>

      {showExternalLink && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
          <a
            href={parsed.rawUrl}
            target="_blank"
            rel="noreferrer"
            style={{
              color: 'var(--primary, #00aeef)',
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 4,
              fontSize: 13,
              fontWeight: 600,
            }}
          >
            🔗 Videoyu Yeni Sekmede Aç ↗
          </a>
        </div>
      )}
    </div>
  );
};
